import React, { FC } from 'react'
import s from './FilterMap.module.sass'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { BtnFilterMap } from '@shared/ui/Form/Single/Filters/ButtonMap'
import { openMapAC, TypePropsOpenMapAC } from '@widgets/Restaurant/Map/model/actions'

const FilterMap: FC = () => {
  const { loading, output } = useAppSelector((store) => store.features.restaurant_filters)
  const dispatch = useAppDispatch()

  const handleClick = () => {
    const params: TypePropsOpenMapAC = {}
    if (output.slugs?.length) params.applyFilters = output.slugs
    else if (output.restaurants?.length) params.preloadRests = output.restaurants

    dispatch(openMapAC(params))
  }

  return <BtnFilterMap onClick={handleClick} />
}

export default FilterMap
